// extracted by mini-css-extract-plugin
module.exports = {"my-equipment":"my-equipment-skeleton_my-equipment__R5UDP"};